var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({attrs:{"dense":"","outlined":"","clearable":_vm.clearable,"type":"date","error":_vm.error,"error-messages":_vm.error_message,"hide-details":!_vm.property_state_field_name},on:{"input":_vm.onInput}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }